import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from 'src/app/services/loader-service/loader.service';

@Injectable()
export class HttpDefaultInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      !req.url.includes('/SendMessage') &&
      !req.url.includes('/UploadImage') &&
      !req.url.includes('/CreateProperty') &&
      !req.url.includes('/advanced') &&
      !req.url.includes('/Messages')
    ) {
      this.loaderService.show();
    }

    const request = req.clone({
      setHeaders: {
        accept: 'application/json',
      },
    });

    return next.handle(request).pipe(
      finalize(() => {
        this.loaderService.hide();
      }),
    );
  }
}
